<template>
  <b-row v-if="problemsOptions.length > 0">
    <b-col cols="12">
      <hr class="mt-1 mb-2">
      <span class="h6">{{$t("views.excmcase.show.categorizationDescription")}}: </span>
    </b-col>
    <b-col>
      <template v-if="data.caseProblems && data.caseProblems.length > 0">
        <b-row v-for="(item, index) in data.caseProblems" :key="index">
          <div class="text-center d-inline-block align-self-center ml-3">
            <button
              type="button"
              class="btn btn-link fa fa-trash fa-lg"
              @click="removeDevice(index)"
              v-b-tooltip :title="$t('buttons.delete')">
            </button>
          </div>
          <b-col md="4">
            <model-select v-model="data.caseProblems[index].idProblem" :options="problemsOptions" :placeholder="$t('views.agreements.form.select')" required class="mb-1 mt-2" name="item">
            </model-select>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col>
          <b-button class="btn btn-primary" @click="addNewProblem()">{{ $t('buttons.addCategory') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import remove from '@/utils/remove'
import ApiService from '@/utils/ApiService'

export default {
  name: 'CaseProblems',
  components: {
    ModelSelect
  },

  props: ['data', 'violations'],

  data () {
    return {
      problemsOptions: []
    }
  },

  created () {
    this.fetchProblems()
  },
  methods: {
    async fetchProblems () {
      let params = {
        'pagination': false
      }
      const response = await new ApiService('e_x_c_m_problems', params).getResults()
      this.problemsOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    addNewProblem () {
      let item = {}
      this.data.caseProblems.push(item)
    },
    removeDevice (index) {
      let currentProblem = this.data.caseProblems[index]
      if (currentProblem['@id']) {
        remove(currentProblem['@id'], () => {
          this.data.caseProblems.splice(index, 1)
        })
      } else {
        this.data.caseProblems.splice(index, 1)
      }
    }
  }
}
</script>
